const initialState = {
  datos: [],
  loading: true,
  status: null,
  loadingTableSpiner: false,
  count: {},
  statusCount: null,
  downloading: false,
  filters: {
    otherFilters: {}
  },
  activeTask: {
    id: null,
    datos: null,
    loading: false,
    status: null
  },
  saveTask: {
    id: null,
    action: null,
    datos: null,
    loading: false,
    status: null,
    message: null
  },
  annulTasks: {
    loading: false,
    status: null
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/tasks_manager_tab_notifications/initialState.js